export default Object.freeze({
    PHYSICIAN: 'physician',
    ANCILLARY: 'ancillary',
    OTHER: 'other',
    DEMO_PHYSICIAN: 'demo-physician',
    DEMO_ANCILLARY: 'demo-ancillary',
    DEMO_PRIMARY_CARE: 'demo-primary-care',
})
